/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { usePrefixClass } from '../../hooks/useConfig.mjs';
import 'vue';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-bfb23a5e.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../../_chunks/dep-2a7dc5c7.mjs';
import '../../_chunks/dep-9311bf66.mjs';
import '../../_chunks/dep-4889eb51.mjs';
import '../../_chunks/dep-0b4185fe.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-d2403b2f.mjs';
import '../../_chunks/dep-7922050a.mjs';
import '../../_chunks/dep-169ea640.mjs';
import '../../_chunks/dep-f6b25712.mjs';
import '../../_chunks/dep-59545a4d.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../_chunks/dep-7d96367f.mjs';
import '../../_chunks/dep-827c4600.mjs';
import '../../_chunks/dep-0820e0e2.mjs';
import '../../_chunks/dep-caad2e91.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-8e38f523.mjs';
import '../../_chunks/dep-469bf54b.mjs';
import '../../_chunks/dep-8ef9fb8e.mjs';
import '../../_chunks/dep-e769aafd.mjs';
import '../../_chunks/dep-400798c5.mjs';
import '../../_chunks/dep-361522ee.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../config-provider/type.mjs';

function useClassName() {
  var classPrefix = usePrefixClass();
  var classNames = {
    tableBaseClass: {
      table: "".concat(classPrefix.value, "-table"),
      columnResizableTable: "".concat(classPrefix.value, "-table--column-resizable"),
      overflowVisible: "".concat(classPrefix.value, "-table--overflow-visible"),
      body: "".concat(classPrefix.value, "-table__body"),
      content: "".concat(classPrefix.value, "-table__content"),
      topContent: "".concat(classPrefix.value, "-table__top-content"),
      bottomContent: "".concat(classPrefix.value, "-table__bottom-content"),
      paginationWrap: "".concat(classPrefix.value, "-table__pagination-wrap"),
      tdLastRow: "".concat(classPrefix.value, "-table__td-last-row"),
      tdFirstCol: "".concat(classPrefix.value, "-table__td-first-col"),
      thCellInner: "".concat(classPrefix.value, "-table__th-cell-inner"),
      tableRowEdit: "".concat(classPrefix.value, "-table--row-edit"),
      cellEditable: "".concat(classPrefix.value, "-table__cell--editable"),
      cellEditWrap: "".concat(classPrefix.value, "-table__cell-wrap"),
      bordered: "".concat(classPrefix.value, "-table--bordered"),
      striped: "".concat(classPrefix.value, "-table--striped"),
      hover: "".concat(classPrefix.value, "-table--hoverable"),
      loading: "".concat(classPrefix.value, "-table--loading"),
      rowspanAndColspan: "".concat(classPrefix.value, "-table--rowspan-colspan"),
      empty: "".concat(classPrefix.value, "-table__empty"),
      emptyRow: "".concat(classPrefix.value, "-table__empty-row"),
      headerFixed: "".concat(classPrefix.value, "-table--header-fixed"),
      columnFixed: "".concat(classPrefix.value, "-table--column-fixed"),
      widthOverflow: "".concat(classPrefix.value, "-table--width-overflow"),
      multipleHeader: "".concat(classPrefix.value, "-table--multiple-header"),
      footerAffixed: "".concat(classPrefix.value, "-table--footer-affixed"),
      horizontalBarAffixed: "".concat(classPrefix.value, "-table--horizontal-bar-affixed"),
      affixedHeader: "".concat(classPrefix.value, "-table--affixed-header"),
      affixedHeaderElm: "".concat(classPrefix.value, "-table__affixed-header-elm"),
      affixedFooterElm: "".concat(classPrefix.value, "-table__affixed-footer-elm"),
      affixedFooterWrap: "".concat(classPrefix.value, "-table__affixed-footer-wrap"),
      scrollbarDivider: "".concat(classPrefix.value, "-table__scroll-bar-divider"),
      fullHeight: "".concat(classPrefix.value, "-table--full-height"),
      resizeLine: "".concat(classPrefix.value, "-table__resize-line"),
      obviousScrollbar: "".concat(classPrefix.value, "-table__scrollbar--obvious"),
      affixedHeaderWrap: "".concat(classPrefix.value, "-table__affixed-header-elm-wrap")
    },
    tdAlignClasses: {
      left: "".concat(classPrefix.value, "-align-left"),
      right: "".concat(classPrefix.value, "-align-right"),
      center: "".concat(classPrefix.value, "-align-center")
    },
    tableHeaderClasses: {
      header: "".concat(classPrefix.value, "-table__header"),
      thBordered: "".concat(classPrefix.value, "-table__header-th--bordered"),
      fixed: "".concat(classPrefix.value, "-table__header--fixed"),
      multipleHeader: "".concat(classPrefix.value, "-table__header--multiple")
    },
    tableFooterClasses: {
      footer: "".concat(classPrefix.value, "-table__footer"),
      fixed: "".concat(classPrefix.value, "-table__footer--fixed")
    },
    tableAlignClasses: {
      top: "".concat(classPrefix.value, "-vertical-align-top"),
      middle: "".concat(classPrefix.value, "-vertical-align-middle"),
      bottom: "".concat(classPrefix.value, "-vertical-align-bottom")
    },
    tableRowFixedClasses: {
      top: "".concat(classPrefix.value, "-table__row--fixed-top"),
      bottom: "".concat(classPrefix.value, "-table__row--fixed-bottom"),
      firstBottom: "".concat(classPrefix.value, "-table__row--fixed-bottom-first"),
      withoutBorderBottom: "".concat(classPrefix.value, "-table__row--without-border-bottom")
    },
    tableColFixedClasses: {
      left: "".concat(classPrefix.value, "-table__cell--fixed-left"),
      right: "".concat(classPrefix.value, "-table__cell--fixed-right"),
      lastLeft: "".concat(classPrefix.value, "-table__cell--fixed-left-last"),
      firstRight: "".concat(classPrefix.value, "-table__cell--fixed-right-first"),
      leftShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-left"),
      rightShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-right")
    },
    tableLayoutClasses: {
      auto: "".concat(classPrefix.value, "-table--layout-auto"),
      fixed: "".concat(classPrefix.value, "-table--layout-fixed")
    },
    tdEllipsisClass: "".concat(classPrefix.value, "-table-td--ellipsis"),
    tableFullRowClasses: {
      base: "".concat(classPrefix.value, "-table__row--full"),
      innerFullRow: "".concat(classPrefix.value, "-table__row-full-inner"),
      innerFullElement: "".concat(classPrefix.value, "-table__row-full-element"),
      firstFullRow: "".concat(classPrefix.value, "-table__first-full-row"),
      lastFullRow: "".concat(classPrefix.value, "-table__last-full-row")
    },
    tableExpandClasses: {
      iconBox: "".concat(classPrefix.value, "-table__expand-box"),
      iconCell: "".concat(classPrefix.value, "-table__expandable-icon-cell"),
      row: "".concat(classPrefix.value, "-table__expanded-row"),
      rowInner: "".concat(classPrefix.value, "-table__expanded-row-inner"),
      expanded: "".concat(classPrefix.value, "-table__row--expanded"),
      collapsed: "".concat(classPrefix.value, "-table__row--collapsed")
    },
    tableSortClasses: {
      sortable: "".concat(classPrefix.value, "-table__cell--sortable"),
      title: "".concat(classPrefix.value, "-table__cell--title"),
      trigger: "".concat(classPrefix.value, "-table__cell--sort-trigger"),
      doubleIcon: "".concat(classPrefix.value, "-table__double-icons"),
      sortIcon: "".concat(classPrefix.value, "-table__sort-icon"),
      iconDirection: {
        asc: "".concat(classPrefix.value, "-table-sort-asc"),
        desc: "".concat(classPrefix.value, "-table-sort-desc")
      },
      iconActive: "".concat(classPrefix.value, "-table__sort-icon--active"),
      iconDefault: "".concat(classPrefix.value, "-icon-sort--default")
    },
    tableSelectedClasses: {
      selected: "".concat(classPrefix.value, "-table__row--selected"),
      disabled: "".concat(classPrefix.value, "-table__row--disabled"),
      checkCell: "".concat(classPrefix.value, "-table__cell-check")
    },
    tableFilterClasses: {
      filterable: "".concat(classPrefix.value, "-table__cell--filterable"),
      popup: "".concat(classPrefix.value, "-table__filter-pop"),
      icon: "".concat(classPrefix.value, "-table__filter-icon"),
      popupContent: "".concat(classPrefix.value, "-table__filter-pop-content"),
      result: "".concat(classPrefix.value, "-table__filter-result"),
      inner: "".concat(classPrefix.value, "-table__row-filter-inner"),
      bottomButtons: "".concat(classPrefix.value, "-table__filter--bottom-buttons"),
      contentInner: "".concat(classPrefix.value, "-table__filter-pop-content-inner"),
      iconWrap: "".concat(classPrefix.value, "-table__filter-icon-wrap")
    },
    asyncLoadingClass: "".concat(classPrefix.value, "-table__async-loading"),
    isFocusClass: "".concat(classPrefix.value, "-is-focus"),
    isLoadingClass: "".concat(classPrefix.value, "-is-loading"),
    isLoadMoreClass: "".concat(classPrefix.value, "-is-load-more"),
    tableTreeClasses: {
      col: "".concat(classPrefix.value, "-table__tree-col"),
      inlineCol: "".concat(classPrefix.value, "-table__tree-col--inline"),
      icon: "".concat(classPrefix.value, "-table__tree-op-icon")
    },
    tableDraggableClasses: {
      rowDraggable: "".concat(classPrefix.value, "-table--row-draggable"),
      rowHandlerDraggable: "".concat(classPrefix.value, "-table--row-handler-draggable"),
      colDraggable: "".concat(classPrefix.value, "-table--col-draggable"),
      handle: "".concat(classPrefix.value, "-table__handle-draggable"),
      ghost: "".concat(classPrefix.value, "-table__ele--draggable-ghost"),
      chosen: "".concat(classPrefix.value, "-table__ele--draggable-chosen"),
      dragging: "".concat(classPrefix.value, "-table__ele--draggable-dragging")
    },
    virtualScrollClasses: {
      cursor: "".concat(classPrefix.value, "-table__virtual-scroll-cursor"),
      header: "".concat(classPrefix.value, "-table__virtual-scroll-header")
    },
    positiveRotate90: "".concat(classPrefix.value, "-positive-rotate-90"),
    negativeRotate180: "".concat(classPrefix.value, "-negative-rotate-180")
  };
  return classNames;
}

export { useClassName as default };
//# sourceMappingURL=useClassName.mjs.map
